import React, { useEffect, useState, useMemo, useRef } from 'react';
import '../../../index.scss';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
import { isType, isType3, isTypeBK, userTypeList, localeTw } from 'main_consts';

// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import { setLoadingRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
// component
import DateSePickersTyping from 'components/DatePicker/DateSePickersTyping';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';
import { AgGridReact } from 'ag-grid-react';
import {
  ColDef,
  Column,
  GridOptions,
  GridOptionsWrapper,
} from 'ag-grid-community';
import Header from 'components/Header';
import Menu from '../../../components/Menu';
import {
  formatDateTime,
  getDateDayPlus,
  getExpressName,
  getColWidthByField,
  getWarehouse,
  inputChange,
  initWhrehhouse,
  getEhuFunctionChk,
  EhuFunctionChkResult,
  radioChange,
  formatDate,
  selectChange,
  startDateAfterLast3monthVerify,
} from '../../../main_func';
import Select from '../../../components/Material/Select';

import Input from '../../../components/Material/Input';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getSearch,
  snackBarRsp,
  postSearch,
  postExcel,
} from '../../../main_api';

import Table from '../../../components/Material/Table/index';
import { Imaster } from './type';
import { Iobject, Ioption } from '../../../main_type';
import { EnumMaster } from './enum';
import Radio from '../../../components/Radio';
import QryInput from './QryInput';

/** 稅費明細查詢 */
const ExpTaxDetailQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);

  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 記帳代號
    [EnumMaster.chkCode1]:
      (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    [EnumMaster.expressCnName]: '',
    // 主號
    [EnumMaster.mawbNo]: '',
    // 快遞倉站
    [EnumMaster.warehouse]:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    // 日期
    [EnumMaster.startDate]: getDateDayPlus(),
    [EnumMaster.endDate]: getDateDayPlus(),
    [EnumMaster.startTime]: '0000',
    [EnumMaster.endTime]: '2359',
    [EnumMaster.endDateValid]: true,
    [EnumMaster.endTimeValid]: true,
    [EnumMaster.startDateValid]: true,
    [EnumMaster.startTimeValid]: true,

    qryType: '1',
    sortType: '0',

    qryInputType1: '1',
    qryInputType2: '1',
    qryInputType3: '1',
    qryInputType4: '1',
    qryInputType5: '1',
    qryInputType6: '1',
    qryInputType7: '1',
    qryInputType8: '1',
    qryInputType9: '1',
    qryInputType10: '1',

    mawb1: '',
    mawb2: '',
    mawb3: '',
    mawb4: '',
    mawb5: '',
    mawb6: '',
    mawb7: '',
    mawb8: '',
    mawb9: '',
    mawb10: '',

    hawb1: '',
    hawb2: '',
    hawb3: '',
    hawb4: '',
    hawb5: '',
    hawb6: '',
    hawb7: '',
    hawb8: '',
    hawb9: '',
    hawb10: '',

    dutyNo1: '',
    dutyNo2: '',
    dutyNo3: '',
    dutyNo4: '',
    dutyNo5: '',
    dutyNo6: '',
    dutyNo7: '',
    dutyNo8: '',
    dutyNo9: '',
    dutyNo10: '',

    ban: '',
    defDutyCode: '',
    declNo: '',
  };
  const apiName = 'expTaxDetailQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [rowData, setRowData] = useState<Imaster[]>([]);
  const [colList, setColList] = useState<GridColDef[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [sortOptions, setSortOptions] = useState<Ioption[]>([]);

  const [chkCode1Show, setChkCode1Show] = useState(true);
  const [warehouseShow, setWarehouseShow] = useState(true);

  const [EhuFunctionChk, setEhuFunctionChkResult] =
    useState<EhuFunctionChkResult>({
      aspUserId: '',
      userName: '',
      usertype: '',
      locationCode: '',
      boxNo: '',
      ban: '',
      asType: '',
      chkCode1: '',
      chkCode2: '',
      chkCode3: '',
      userId: '',
      updTime: '',
      roleType: '',
      sender_id: '',
      uvFlag: '',
      boxno1: '',
    });

  const getColumnDefs = (status: boolean): ColDef[] => {
    return [
      {
        // headerCheckboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        // checkboxSelection: true,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '主號',
        field: 'mawbNo',
        width: 300,
      },
      {
        headerName: '分號',
        field: 'hawbNo',
        width: 300,
      },
      {
        headerName: '報單號碼',
        field: 'declNo',
        width: 300,
      },
      {
        headerName: '類別',
        field: 'appType',
        width: 150,
      },
      {
        headerName: '快遞倉站',
        field: 'warehouse',
        width: 200,
      },
      {
        headerName: '報關箱號',
        field: 'boxNo',
        width: 200,
      },
      {
        headerName: '櫃號',
        field: 'containerNo',
        width: 300,
      },
      {
        headerName: '申報重量',
        field: 'weight',
        width: 200,
      },
      {
        headerName: '稅單號碼',
        field: 'dutyNo',
        width: 300,
      },
      {
        headerName: '進口納稅義務人身分證號',
        field: 'dutyPayerId',
        width: 300,
      },
      {
        headerName: '進口納稅義務人',
        field: 'dutyPayerNameC',
        width: 300,
      },
      {
        headerName: '稅費合計',
        field: 'totalDutyAmt',
        width: 150,
      },
      {
        headerName: '營業稅稅基',
        field: 'taxBasis',
        width: 150,
      },
      {
        headerName: '授權統編',
        field: 'defDutyCode',
        width: 150,
        hide: status,
      },
      {
        headerName: '自定義欄1',
        field: 'defDutyMark1',
        minWidth: 200,
        hide: status,
      },
      {
        headerName: '自定義欄2',
        field: 'defDutyMark2',
        width: 200,
        hide: status,
      },
      {
        headerName: '稅費代碼1',
        field: 'dutyChargeCode1',
        width: 150,
      },
      {
        headerName: '稅費金額1',
        field: 'dutyAmt1',
        width: 150,
      },
      {
        headerName: '稅費代碼2',
        field: 'dutyChargeCode2',
        width: 150,
      },
      {
        headerName: '稅費金額2',
        field: 'dutyAmt2',
        width: 150,
      },
      {
        headerName: '稅費代碼3',
        field: 'dutyChargeCode3',
        width: 150,
      },
      {
        headerName: '稅費金額3',
        field: 'dutyAmt3',
        width: 150,
      },
      {
        headerName: '稅費代碼4',
        field: 'dutyChargeCode4',
        width: 150,
      },
      {
        headerName: '稅費金額4',
        field: 'dutyAmt4',
        width: 150,
      },
      {
        headerName: '稅費代碼5',
        field: 'dutyChargeCode5',
        width: 150,
      },
      {
        headerName: '稅費金額5',
        field: 'dutyAmt5',
        width: 150,
      },
      {
        headerName: '稅費代碼6',
        field: 'dutyChargeCode6',
        width: 150,
      },
      {
        headerName: '稅費金額6',
        field: 'dutyAmt6',
        width: 150,
      },
      {
        headerName: '稅費代碼7',
        field: 'dutyChargeCode7',
        width: 150,
      },
      {
        headerName: '稅費金額7',
        field: 'dutyAmt7',
        width: 150,
      },
      {
        headerName: '稅費代碼8',
        field: 'dutyChargeCode8',
        width: 150,
      },
      {
        headerName: '稅費金額8',
        field: 'dutyAmt8',
        width: 150,
      },
      {
        headerName: '稅費代碼9',
        field: 'dutyChargeCode9',
        width: 150,
      },
      {
        headerName: '稅費金額9',
        field: 'dutyAmt9',
        width: 150,
      },
    ];
  };

  const onFirstDataRendered = (params: any) => {
    // params.api.sizeColumnsToFit();
  };

  const gridRef = useRef<any>(undefined);
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs(false);

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
      // colResizeDefault: 'shift',
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    // params.api.sizeColumnsToFit();
  };

  useEffect(() => {
    getEhuFunctionChk().then((item) => {
      setEhuFunctionChkResult(item);

      const list: Ioption[] = [];
      list.push({ value: '0', label: '' });

      list.push({ value: '1', label: '主號+分號' });
      if (item.chkCode3 === 'Y') {
        list.push({ value: '2', label: '出倉日' });
      }
      list.push({ value: '3', label: '進口日' });
      if (
        userType &&
        (isType(userTypeList.type5, userType) || isTypeBK(userType)) &&
        item.roleType === '1'
      ) {
        list.push({ value: '4', label: '授權稅單統編' });
        list.push({ value: '5', label: '自定義欄1' });
        list.push({ value: '6', label: '自定義欄2' });
      }
      setSortOptions(list);

      if (
        userType &&
        (isType(userTypeList.type5, userType) || isType3(userType))
      ) {
        setChkCode1Show(false);
      }
      if (userType && isType(userTypeList.type5, userType)) {
        setWarehouseShow(false);
      }
      if (item.chkCode3 !== 'Y') {
        setChkCode1Show(false);
        setWarehouseShow(false);
      }
    });

    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
  }, [userType]);

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    // 1 => 主分號 2 => 稅單號碼
    const type1Result: { mawbNo: string; hawbNo: string }[] = [];
    const type2Result: string[] = [];
    if (master.qryType === '2') {
      for (let i = 1; i <= 10; i += 1) {
        if (master[`qryInputType${i}`] === '1') {
          if (
            (master[`mawb${i}`] as string).length > 0 ||
            (master[`hawb${i}`] as string).length > 0
          ) {
            type1Result.push({
              mawbNo: master[`mawb${i}`] as string,
              hawbNo: master[`hawb${i}`] as string,
            });
          }
        } else if ((master[`dutyNo${i}`] as string).length > 0) {
          type2Result.push(master[`dutyNo${i}`] as string);
        }
      }
    }

    const result = await postExcel(apiName, {
      chkCode1: chkCode1Show ? master[EnumMaster.chkCode1] : '',
      warehouse: warehouseShow ? master[EnumMaster.warehouse] : '',
      qryType: master.qryType,
      sortType: master.sortType,
      importStartDate:
        master.qryType === '1' ? formatDate(master.startDate, 'yyyyMMdd') : '',
      importEndDate:
        master.qryType === '1' ? formatDate(master.endDate, 'yyyyMMdd') : '',
      gcoStartDate:
        master.qryType === '4'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      gcoEndDate:
        master.qryType === '4'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
      mawbNo: master.qryType === '3' ? master.mawbNo : '',
      declNo: '',
      ban: master.ban,
      defDutyCode: master.defDutyCode,
      mawbNoAndHawbNoList: type1Result,
      dutyNoList: type2Result,
    });

    blobDownload(
      result,
      enqueueSnackbar,
      `${EhuFunctionChk.aspUserId}_${
        master.qryType === '1' || master.qryType === '4'
          ? `${formatDate(master.startDate, 'MMdd')}_${formatDate(
              master.endDate,
              'MMdd'
            )}`
          : formatDate(getDateDayPlus(), 'MMdd')
      }_稅費明細查詢.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    // 1 => 主分號 2 => 稅單號碼
    const type1Result: { mawbNo: string; hawbNo: string }[] = [];
    const type2Result: string[] = [];
    if (master.qryType === '2') {
      for (let i = 1; i <= 10; i += 1) {
        if (master[`qryInputType${i}`] === '1') {
          if (
            (master[`mawb${i}`] as string).length > 0 ||
            (master[`hawb${i}`] as string).length > 0
          ) {
            type1Result.push({
              mawbNo: master[`mawb${i}`] as string,
              hawbNo: master[`hawb${i}`] as string,
            });
          }
        } else if ((master[`dutyNo${i}`] as string).length > 0) {
          type2Result.push(master[`dutyNo${i}`] as string);
        }
      }
    }

    const result = await postSearch(apiName, {
      chkCode1: chkCode1Show ? master[EnumMaster.chkCode1] : '',
      warehouse: warehouseShow ? master[EnumMaster.warehouse] : '',
      qryType: master.qryType,
      sortType: master.sortType,
      importStartDate:
        master.qryType === '1' ? formatDate(master.startDate, 'yyyyMMdd') : '',
      importEndDate:
        master.qryType === '1' ? formatDate(master.endDate, 'yyyyMMdd') : '',
      gcoStartDate:
        master.qryType === '4'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      gcoEndDate:
        master.qryType === '4'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
      mawbNo: master.qryType === '3' ? master.mawbNo : '',
      declNo: '',
      ban: master.ban,
      defDutyCode: master.defDutyCode,
      mawbNoAndHawbNoList: type1Result,
      dutyNoList: type2Result,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    const { data: dataTemp } = result.data;
    const apiData = dataTemp as Imaster[];
    if ((apiData || []).length > 0) {
      // setColList(
      //   getColWidthByField([
      //     { headerName: '項次', field: 'itemNo' },
      //     { headerName: '主號', field: 'mawbNo' },
      //     { headerName: '分號', field: 'hawbNo' },
      //     { headerName: '報單號碼', field: 'declNo' },
      //     { headerName: '類別', field: 'appType' },
      //     { headerName: '快遞倉站', field: 'warehouse' },
      //     { headerName: '報關箱號', field: 'boxNo' },
      //     { headerName: '櫃號', field: 'containerNo' },
      //     { headerName: '申報重量', field: 'weight' },
      //     { headerName: '稅單號碼', field: 'dutyNo' },
      //     { headerName: '進口納稅義務人', field: 'dutyPayerNameC' },
      //     // { headerName: '已列印(時間)', field: 'printduty' },
      //     { headerName: '稅費合計', field: 'totalDutyAmt' },
      //     { headerName: '營業稅稅基', field: 'taxBasis' },
      //     {
      //       headerName: '授權稅單統編',
      //       field: 'defDutyCode',
      //       hide: !(
      //         EhuFunctionChk.roleType === '1' &&
      //         (isType(userTypeList.type5, userType) || isTypeBK(userType))
      //       ),
      //     },
      //     {
      //       headerName: '自定義欄1',
      //       field: 'defDutyMark1',
      //       hide: !(
      //         EhuFunctionChk.roleType === '1' &&
      //         (isType(userTypeList.type5, userType) || isTypeBK(userType))
      //       ),
      //     },
      //     {
      //       headerName: '自定義欄2',
      //       field: 'defDutyMark2',
      //       hide: !(
      //         EhuFunctionChk.roleType === '1' &&
      //         (isType(userTypeList.type5, userType) || isTypeBK(userType))
      //       ),
      //     },

      //     { headerName: '稅費代碼1', field: 'dutyChargeCode1' },
      //     { headerName: '稅費金額1', field: 'dutyAmt1' },

      //     { headerName: '稅費代碼2', field: 'dutyChargeCode2' },
      //     { headerName: '稅費金額2', field: 'dutyAmt2' },

      //     { headerName: '稅費代碼3', field: 'dutyChargeCode3' },
      //     { headerName: '稅費金額3', field: 'dutyAmt3' },

      //     { headerName: '稅費代碼4', field: 'dutyChargeCode4' },
      //     { headerName: '稅費金額4', field: 'dutyAmt4' },

      //     { headerName: '稅費代碼5', field: 'dutyChargeCode5' },
      //     { headerName: '稅費金額5', field: 'dutyAmt5' },

      //     { headerName: '稅費代碼6', field: 'dutyChargeCode6' },
      //     { headerName: '稅費金額6', field: 'dutyAmt6' },

      //     { headerName: '稅費代碼7', field: 'dutyChargeCode7' },
      //     { headerName: '稅費金額7', field: 'dutyAmt7' },

      //     { headerName: '稅費代碼8', field: 'dutyChargeCode8' },
      //     { headerName: '稅費金額8', field: 'dutyAmt8' },

      //     { headerName: '稅費代碼9', field: 'dutyChargeCode9' },
      //     { headerName: '稅費金額9', field: 'dutyAmt9' },
      //   ])
      // );

      setRowData(apiData);
      setOpenSearchTable(true);
      const columnDefs = getColumnDefs(
        !(
          EhuFunctionChk.roleType === '1' &&
          (isType(userTypeList.admin, userType) ||
            isType(userTypeList.type5, userType) ||
            isTypeBK(userType))
        )
      );

      gridRef.current!.api.setColumnDefs(columnDefs);
      const allColumnIds: string[] = [];
      gridOptions.columnApi?.getAllColumns()?.forEach((colName) => {
        allColumnIds.push(colName.getColId());
      });
      gridOptions.columnApi?.autoSizeColumns(allColumnIds);
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }

    if (
      !master[EnumMaster.endDateValid] ||
      !master[EnumMaster.endTimeValid] ||
      !master[EnumMaster.startDateValid] ||
      !master[EnumMaster.startTimeValid] ||
      !(
        master[EnumMaster.startDate] &&
        master[EnumMaster.endTime] &&
        master[EnumMaster.startDate] &&
        master[EnumMaster.startTime]
      )
    ) {
      return;
    }

    let canQry: boolean;
    canQry = false;
    switch (master.qryType) {
      case '2':
        for (let i = 1; i <= 10; i += 1) {
          if (master[`qryInputType${i}`] === '1') {
            if (
              (master[`mawb${i}`] as string).length > 0 &&
              (master[`hawb${i}`] as string).length > 0
            ) {
              canQry = true;
            }
          } else if ((master[`dutyNo${i}`] as string).length > 0) {
            canQry = true;
          }
        }
        if (!canQry) {
          enqueueSnackbar(`至少要輸入一筆主分號/稅單號碼!`);
        }
        break;
      case '3':
        if (master.mawbNo.trim() !== '') {
          canQry = true;
        } else {
          enqueueSnackbar('【主號】必填。', {
            variant: 'warning',
          });
        }
        break;
      default:
        canQry = true;
        break;
    }

    if (!canQry) {
      return;
    }

    if (
      EhuFunctionChk.roleType !== '1' &&
      !isType(userTypeList.admin, userType)
    ) {
      if (master.qryType === '1' || master.qryType === '4') {
        if (
          !startDateAfterLast3monthVerify(master.startDate, enqueueSnackbar)
        ) {
          return;
        }
      }
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length && warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length && chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);

    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            稅單資料查詢
          </Link>
          <Typography color="textPrimary">稅費明細查詢</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 稅費明細查詢
          </div>
        </div>
        <div className="input-area">
          <div>
            {/* 20210325 新增權限判斷 */}
            {chkCode1Show && (
              <Grid container>
                <VcEGrid item xs={12} sm={2} className="input-text">
                  記帳代號：
                </VcEGrid>

                <VcGrid item xs={12} sm={2}>
                  <Input
                    name={EnumMaster.chkCode1}
                    disabled={userTypeList.type2.indexOf(userType) !== -1}
                    maxLength={4}
                    value={master[EnumMaster.chkCode1]}
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </VcGrid>
                <VcGrid item xs={12} sm={3}>
                  {expressName && (
                    <Alert
                      style={{
                        width: '100%',
                        color: 'red',
                        margin: '0 0.5rem',
                        fontSize: '1em',
                      }}
                      severity="info"
                      icon={false}
                    >
                      {expressName}
                    </Alert>
                  )}
                </VcGrid>
              </Grid>
            )}
          </div>
          <div>
            {warehouseShow && (
              <Grid container>
                <VcEGrid item xs={12} sm={2} className="input-text">
                  <FormTitle>
                    {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                      userType
                    ) !== -1
                      ? '*'
                      : ''}
                    快遞倉站：
                  </FormTitle>
                </VcEGrid>
                <VcGrid item xs={12} sm={2}>
                  <WarehouseModal
                    value={master[EnumMaster.warehouse]}
                    updateData={updateData}
                    setStatus={setWarehouseName}
                  />
                </VcGrid>

                <VcGrid item xs={12} sm={3}>
                  {warehouseName && (
                    <Alert
                      severity="info"
                      style={{
                        width: '100%',
                        color: 'red',
                        margin: '0 0.5rem',
                        fontSize: '1em',
                      }}
                      icon={false}
                    >
                      {warehouseName}
                    </Alert>
                  )}
                </VcGrid>
              </Grid>
            )}
          </div>

          <div>
            {userType &&
              !isType(userTypeList.type5, userType) &&
              EhuFunctionChk.roleType === '1' && (
                <Grid container>
                  <VcEGrid item xs={12} sm={2} className="input-text">
                    貨主統編：
                  </VcEGrid>
                  <Grid item xs={12} sm={2}>
                    <Input
                      maxLength={8}
                      value={master.ban}
                      name="ban"
                      onChange={(e) => {
                        inputChange(updateData)(e);
                      }}
                    />
                  </Grid>
                </Grid>
              )}
          </div>
          <div>
            {userType &&
              (isType(userTypeList.admin, userType) ||
                isType(userTypeList.topType, userType) ||
                isType(userTypeList.type4, userType) ||
                isTypeBK(userType)) &&
              EhuFunctionChk.roleType &&
              EhuFunctionChk.roleType === '1' && (
                <Grid container>
                  <VcEGrid item xs={12} sm={2} className="input-text">
                    授權稅單統編：
                  </VcEGrid>
                  <Grid item xs={12} sm={2}>
                    <Input
                      maxLength={8}
                      value={master.defDutyCode}
                      name="defDutyCode"
                      onChange={(e) => {
                        inputChange(updateData)(e);
                      }}
                    />
                  </Grid>
                </Grid>
              )}
          </div>

          {/* <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>排序選項：</FormTitle>
              </VcEGrid>
              <Grid item xs={12} sm={3}>
                <Select
                  // placeholder="請先填入分號"
                  value={master.sortType}
                  onChange={selectChange(updateData)}
                  name="sortType"
                  options={sortOptions}
                  // disabled={options.length === 0}
                />
              </Grid>
            </Grid>
          </div> */}
        </div>
        <div className="input-area">
          {EhuFunctionChk.chkCode3 === 'Y' && EhuFunctionChk.roleType === '1' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>*查詢選項：</FormTitle>
              </VcEGrid>
              <HVcGrid item xs={12} sm={6}>
                <Radio
                  className="input-radio "
                  required
                  name="qryType"
                  value={master.qryType}
                  onChange={radioChange(updateData)}
                  options={[
                    { value: '1', label: '進口日期區間' },
                    { value: '2', label: '主分號/稅單號碼' },
                    { value: '3', label: '主號' },
                    {
                      value: '4',
                      label: '出倉日期區間',
                    },
                  ]}
                />
              </HVcGrid>
            </Grid>
          )}

          {(EhuFunctionChk.chkCode3 !== 'Y' ||
            EhuFunctionChk.roleType !== '1') && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>*查詢選項：</FormTitle>
              </VcEGrid>
              <HVcGrid item xs={12} sm={6}>
                <Radio
                  className="input-radio "
                  required
                  name="qryType"
                  value={master.qryType}
                  onChange={radioChange(updateData)}
                  options={[
                    { value: '1', label: '進口日期區間' },
                    { value: '2', label: '主分號/稅單號碼' },
                    { value: '3', label: '主號' },
                  ]}
                />
              </HVcGrid>
            </Grid>
          )}
          {master.qryType === '1' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>日期區間：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
                <DateSePickersTyping
                  required
                  updateData={updateData}
                  style={{ maxWidth: 600 }}
                  names={['startDate', 'endDate']}
                  data={master}
                  seInterval={31}
                />
              </VcGrid>
            </Grid>
          )}

          {master.qryType === '2' && (
            <>
              <QryInput
                index="1"
                value={{
                  mawbVal: master.mawb1,
                  hawbVal: master.hawb1,
                  dutyNoVal: master.dutyNo1,
                  qryInputType: master.qryInputType1,
                }}
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb2,
                  hawbVal: master.hawb2,
                  dutyNoVal: master.dutyNo2,
                  qryInputType: master.qryInputType2,
                }}
                index="2"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb3,
                  hawbVal: master.hawb3,
                  dutyNoVal: master.dutyNo3,
                  qryInputType: master.qryInputType3,
                }}
                index="3"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb4,
                  hawbVal: master.hawb4,
                  dutyNoVal: master.dutyNo4,
                  qryInputType: master.qryInputType4,
                }}
                index="4"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb5,
                  hawbVal: master.hawb5,
                  dutyNoVal: master.dutyNo5,
                  qryInputType: master.qryInputType5,
                }}
                index="5"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb6,
                  hawbVal: master.hawb6,
                  dutyNoVal: master.dutyNo6,
                  qryInputType: master.qryInputType6,
                }}
                index="6"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb7,
                  hawbVal: master.hawb7,
                  dutyNoVal: master.dutyNo7,
                  qryInputType: master.qryInputType7,
                }}
                index="7"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb8,
                  hawbVal: master.hawb8,
                  dutyNoVal: master.dutyNo8,
                  qryInputType: master.qryInputType8,
                }}
                index="8"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb9,
                  hawbVal: master.hawb9,
                  dutyNoVal: master.dutyNo9,
                  qryInputType: master.qryInputType9,
                }}
                index="9"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb10,
                  hawbVal: master.hawb10,
                  dutyNoVal: master.dutyNo10,
                  qryInputType: master.qryInputType10,
                }}
                index="10"
                fatherUpdateData={updateData}
              />
            </>
          )}
          {master.qryType === '3' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>主號：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <Input
                  name="mawbNo"
                  value={master.mawbNo}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
            </Grid>
          )}

          {master.qryType === '4' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>出倉日期區間：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
                <DateTimeSePickersTyping
                  key={random}
                  required
                  updateData={updateData}
                  style={{ maxWidth: 800 }}
                  names={[
                    ['startDate', 'startTime'],
                    ['endDate', 'endTime'],
                  ]}
                  data={master}
                  setDayRange={31}
                />
              </VcGrid>
            </Grid>
          )}
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
        <div
          style={{
            color: 'red',
            fontWeight: 800,
            marginLeft: '10%',
            padding: 0,
          }}
        >
          1.滑鼠指到欲排序欄位同時按壓「Ctrl」鍵，即可達成排序效果。
        </div>
        <div
          style={{
            color: 'red',
            fontWeight: 800,
            marginLeft: '10%',
            padding: 0,
          }}
        >
          2.稅單查詢與調閱，只留存3個月，已採購稅單雲者除外。
        </div>
      </form>
      {openSearchTable && (
        // <Table
        //   key={randomValue}
        //   data={rowData as unknown as Iobject[]}
        //   columns={colList}
        //   rowsPerPageOptions={[100, 50, 10]}
        //   rootProps={{ style: { height: '400px' } }}
        //   pageSize={100}
        // />

        <div className="ag-theme-alpine" style={{ height: '400px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
            onFirstDataRendered={onFirstDataRendered}
          />
        </div>
      )}
    </div>
  );
};

export default ExpTaxDetailQry;
